import { NavLink } from "react-router-dom";
import { Shield, Package } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { hasPermission } from "@/lib/permissions";

const TABS = [
  { to: "/adminxx1/roles", label: "Rol Yetkileri", icon: Shield, permission: "roles", testid: "access-nav-roles" },
  { to: "/adminxx1/packages", label: "Paketler", icon: Package, permission: "packages", testid: "access-nav-packages" },
];

export default function AccessManagementNav() {
  const { user } = useAuth();
  const visible = TABS.filter((t) => hasPermission(user, t.permission));
  if (visible.length < 2) return null;

  return (
    <nav className="mb-6 flex flex-wrap gap-2 rounded-2xl border border-slate-200/60 bg-white p-1.5 shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
      {visible.map(({ to, label, icon: Icon, testid }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={testid}
          className={({ isActive }) =>
            `flex flex-1 items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors sm:flex-none sm:justify-start ${
              isActive
                ? "bg-violet-600 text-white shadow-sm"
                : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
            }`
          }
        >
          <Icon className="h-4 w-4" />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
